import React, { forwardRef } from 'react'

import { FiveStageInputPropsType } from './FiveStageInput.types'

import styles from './styles.module.scss'

export const FiveStageInput = forwardRef<HTMLInputElement, FiveStageInputPropsType>(({ ...props }, ref) => {
  const { className, ...rest } = props
  const { name } = rest
  return (
    <div className={`${className} ${styles.wrapper}`}>
      {[1, 2, 3, 4, 5].map((stage) => (
        <div key={`${name}-${stage}`}>
          <input className={styles.input} id={`${name}-${stage}`} type="radio" {...rest} ref={ref} value={stage} />
          <label className={styles.label} htmlFor={`${name}-${stage}`} data-first={stage === 1} data-last={stage === 5}>
            {stage}
          </label>
        </div>
      ))}
    </div>
  )
})
